import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "../axios-orders";
import { RespondOcRequest } from "../types";
import { queryKeys } from "./queryKeys";

export interface RespondOcVariables extends RespondOcRequest {
  id: string;
}

/** True when the error is the backend's 404 (the OC is not addressed to the caller's company). */
export const isOcNotFound = (error: unknown): boolean =>
  (error as { response?: { status?: number } } | null)?.response?.status ===
  404;

/**
 * Seller's answer to a SENT OC: accept -> ACCEPTED, reject -> REJECTED_SUPPLIER (a reason is
 * required when rejecting). Refreshes the supplier list on settle, so a 409 (already responded)
 * also pulls the real state and hides the now-invalid actions.
 */
export const useRespondOc = () => {
  const queryClient = useQueryClient();
  return useMutation<unknown, Error, RespondOcVariables>({
    mutationFn: async ({ id, accept, reason }) => {
      const body: RespondOcRequest = { accept };
      if (!accept && reason) body.reason = reason;
      const { data } = await axios.post(`/purchase-orders/${id}/respond`, body);
      return data;
    },
    onSettled: () =>
      queryClient.invalidateQueries({
        queryKey: [queryKeys.SUPPLIER_PURCHASE_ORDERS],
      }),
  });
};
